export default {
    path: "/introduction",
    name: "introduction",
    meta: {
        title: "公司介绍",
        norpermission: true
    },
    redirect: {
        name: "apaasCloud"
    },
    component: () => import("@/views/introduction/introduction/introduction.vue"),
    children: [
        {
            path: "apaasCloud",
            name: "apaasCloud",
            meta: {
                title: "明树低代码平台",
                icon: "bico-PersonalInformation",
                norpermission: true
            },
            component: () => import("@/views/introduction/apaasCloud/apaasCloud.vue")
        },
        // {
        //     path: "dataConsult",
        //     name: "dataConsult",
        //     meta: {
        //         title: "解决方案",
        //         norpermission: true
        //     }
        // },
        {
            path: "dataConsultGov",
            name: "dataConsultGov",
            meta: {
                title: "政府区域项目管理平台",
                icon: "bico-PersonalInformation",
                // parentDir: "dataConsult",
                norpermission: true
            },
            component: () => import("@/views/introduction/dataConsult/dataConsultGov.vue")
        },
        {
            path: "dataConsultFirm",
            name: "dataConsultFirm",
            meta: {
                title: "企业投资项目管理系统",
                icon: "bico-PersonalInformation",
                // parentDir: "dataConsult",
                norpermission: true
            },
            component: () => import("@/views/introduction/dataConsult/dataConsultFirm.vue")
        },

        // {
        //     path: "dataService",
        //     name: "dataService",
        //     meta: {
        //         title: "应用中心",
        //         icon: "bico-PersonalInformation",
        //         norpermission: true
        //     },
        //     component: () => import("@/views/introduction/dataService/dataService.vue")
        // },
        {
            path: "aboutUs",
            name: "introAboutUs",
            meta: {
                title: "合作伙伴计划",
                icon: "bico-PersonalInformation",
                norpermission: true
            },
            component: () => import("@/views/introduction/aboutUs/aboutUs.vue")
        }
        // {
        //     path: "bridataHome",
        //     name: "bridataHome",
        //     meta: {
        //         title: "明树首页",
        //         openUrl: "http://bridata.com",
        //         norpermission: true
        //     }
        // },
        // {
        //     path: "financialOverview",
        //     name: "financialOverview",
        //     meta: {
        //         title: "财政债务系统",
        //         icon: "bico-PersonalInformation",
        //         norpermission: true
        //     },
        //     component: () => import("@/views/introduction/financialOverview/financialOverview.vue")
        // }
    ]
};



// WEBPACK FOOTER //
// ./src/router/modules/introduction.js